require('./bootstrap');
require('./components');

let vm = new Vue({
    el: '#app',
    created: function () {
        window.Vue = this;
    },
    mounted: function () {
        this.$nextTick(function () {});
    }
});

global.vm = vm;
